// import React from 'react'
// import { Link } from 'react-router-dom';

// const User2Header = () => {
//     return (
//         <>
//             <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">

//                 <Link to="/employee/employee-list" className="btn btn-primary">
//                     <span>Back</span>
//                 </Link>
//             </div>

//         </>
//     )
// }

// export default User2Header

import React from "react";
import { Link, useLocation } from "react-router-dom";

const User2Header = ({ permission }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  return (
    <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
       {permission?.pf_add === 1 && (
      <Link to={`/employee/employee-list?id=${M_id}`} className="btn btn-primary">
        <span>Back</span>
      </Link>
       )}
    </div>
  );
};

export default User2Header;
